import React, { useEffect, useState } from 'react';

import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router-dom';

import WorkspaceEditor from '../../components/workspace/WorkspaceEditor';
import ValidationException from '../../exceptions/ValidationException';
import { deepCopy } from '../../utils/lodashUtils';
import useBlocRef from '../../utils/useBlocRef.hook';

export default () => {
  const history = useHistory();
  const blocRef = useBlocRef('createWorkspaceBloc');
  const [validationErrors, setValidationErrors] = useState({});
  const [clinicCode, setClinicCode] = useState('');
  const [ambraNamespaces, setAmbraNamespaces] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const clinicCodeSub = blocRef.current.clinicCode$.subscribe(setClinicCode);
    const ambraNamespacesSub = blocRef.current.ambraNamespaces$.subscribe(setAmbraNamespaces);
    blocRef.current.getAmbraNamespaces();
    return () => {
      clinicCodeSub.unsubscribe();
      ambraNamespacesSub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = async (data) => {
    try {
      await blocRef.current.createWorkspace(data);
      history.push('/workspaces');
    } catch (exception) {
      if (exception instanceof ValidationException) {
        setValidationErrors(exception.errors);
      } else {
        enqueueSnackbar(exception.message, { autoHideDuration: 10000, variant: 'error' });
      }
    }
  };

  const handleCancel = () => {
    history.push('/workspaces');
  };

  const handleRemoveValidationErrorsByKey = (key) => {
    if (!validationErrors[key]) return;

    setValidationErrors((prevState) => {
      const newState = deepCopy(prevState);
      delete newState[key];
      return newState;
    });
  };

  const handleRequestClinicCode = async (clinicName) => {
    try {
      await blocRef.current.requestClinicCode(clinicName);
    } catch (exception) {
      if (exception instanceof ValidationException) {
        setValidationErrors(exception.errors);
      } else {
        enqueueSnackbar(exception.message, { autoHideDuration: 10000, variant: 'error' });
      }
    }
  };

  const handleRejectClinicCode = () => blocRef.current.updateClinicCode('');

  return (
    <WorkspaceEditor
      onSubmit={onSubmit}
      validationErrors={validationErrors}
      onRemoveValidationErrorsByKey={handleRemoveValidationErrorsByKey}
      onCancel={handleCancel}
      clinicCode={clinicCode}
      onRequestClinicCode={handleRequestClinicCode}
      onRejectClinicCode={handleRejectClinicCode}
      isSubmitting$={blocRef.current.isSubmitting$}
      isRequestingCode$={blocRef.current.isRequestingCode$}
      ambraNamespaces={ambraNamespaces}
    />
  );
};
